/** Google Analytics 4 — ID de medición (gtag.js). */
export const GA_MEASUREMENT_ID =
  import.meta.env.VITE_GA_MEASUREMENT_ID?.trim() || 'G-FTC7WJMGRW';
